import React from 'react';
import { FormattedMessage } from 'react-intl';

export const shipmentManifest = {
  id: 'shipment-manifest',

  getDocumentRequestNotificationProps: () => ({
    title: (
      <FormattedMessage
        defaultMessage='Printing Shipment Manifest'
        description='ssConnectEpics.printingShipmentManifestTitle'
        id='sUsTUT'
      />
    ),
  }),
};
